import React, { Fragment, useState, useEffect, useMemo, useCallback } from "react";
import { Link } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { getTask as onGetTasks, resetTaskState } from "../../store/task/action";
import { getEmployeeOne as onGetEmployeeOne, resetEmployeeState } from "../../store/employee/action";
import { Card, Spinner, FormFeedback, Form, Modal, ModalBody, ModalFooter, ModalHeader, CardBody, CardHeader, Col, Container, DropdownItem, DropdownMenu, DropdownToggle, Input, Label, Nav, NavItem, NavLink, Row, TabContent, Table, TabPane, UncontrolledCollapse, UncontrolledDropdown, Button, Accordion, AccordionHeader, AccordionItem, AccordionBody } from "reactstrap";
import SwiperCore, { Autoplay } from "swiper";
import "react-toastify/dist/ReactToastify.css";
import ModalInputFile from "../../Components/ModalInputFile";
import * as Yup from "yup";
import { useFormik } from "formik";
import { api } from "../../config";

import avatar from "../../assets/images/users/user-dummy-img.jpg";
import { getUserOne, updateUser } from "../../store/actions";
import handleValidDate from "../../helpers/utils/handleValidDate";

const SimplePage = () => {
  const { user, success, loading } = useSelector((state) => ({
    success: state.Users.success,
    user: state.Users.user,
    loading: state.Users.loading,
  }));
  const { employee, isEmployeeSuccess } = useSelector((state) => ({
    employee: state.Employee.employee,
    isEmployeeSuccess: state.Employee.isEmployeeSuccess,
  }));
  SwiperCore.use([Autoplay]);

  const [userId, setUserId] = useState("");
  const [userImage, setUserImage] = useState("");
  const [userName, setUserName] = useState("-");
  const [userNameFull, setUserNameFull] = useState("-");
  const [userPosition, setUserPosition] = useState("-");
  const [userPhone, setUserPhone] = useState("-");
  const [userEmail, setUserEmail] = useState("-");
  const [userPass, setUserPass] = useState("");
  const [userDescription, setUserDescription] = useState("");
  const [open, setOpen] = useState("1");
  const [originalFiles, setOriginalFiles] = useState([]);
  const [modal, setModal] = useState(false);
  const [modalMedia, setModalMedia] = useState(false);
  const [logo, setLogo] = useState(avatar);

  const toggleAccordion = (id) => {
    if (open === id) {
      setOpen(open);
    } else {
      setOpen(id);
    }
  };

  const [isSearch, setIsSearch] = useState(false);
  const [isPass, setIsPass] = useState(false);

  const [userData, setUserData] = useState(null);
  const dispatch = useDispatch();

  const { tasks } = useSelector((state) => ({
    tasks: state.Task.tasks,
    isTaskCreated: state.Task.isTaskCreated,
    isTaskSuccess: state.Task.isTaskSuccess,
    loading: state.Task.loading,
    error: state.Task.error,
    employees: state.Employee.employees,
    employeeLoading: state.Employee.loading,
    taskLists: state.TaskList.taskLists,
    taskListLoading: state.TaskList.loading,
    tickets: state.Ticket.tickets,
    ticketLoading: state.Ticket.loading,
  }));

  const statusActiveData = [
    {
      options: [
        { label: "Pending", value: "1" },
        { label: "In Progress", value: "2" },
        { label: "Completed", value: "3" },
      ],
    }];

  const [filterDate, setFilterDate] = useState(null);

  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,
    initialValues: {
      id: userId,
      image: userImage,
      name: userNameFull,
      email: userEmail,
      phone: userPhone,
      password: userPass,
    },
    validationSchema: Yup.object({
      //   name: Yup.string()
      //     .required("Please Enter ContentCategory Name")
      //     .nullable(true),
      //   type: Yup.object().required("Please Pick Type").nullable(true),
      //   company: Yup.object().required("Please Pick Company").nullable(true),
    }),
    onSubmit: (values) => {
      let dataEditImage = {};
      if (isPass) {
        dataEditImage = {
          id: values.id,
          pass: values.password,
        };
      } else {
        dataEditImage = {
          id: values.id,
          name: values.name,
          email: values.email,
          phone: values.phone,
        };
      }
      dispatch(updateUser(dataEditImage));

      toggle();
    },
  });

  useEffect(() => {
    const obj = JSON.parse(localStorage.getItem("authUser"));
    dispatch(getUserOne(obj?.data?.userId));
  }, []);

  useEffect(() => {
    if (user) {
      setUserData(user);
      setUserId(user.id);
      setUserImage(user.image);
      setUserName(user.username);
      setUserPass(user.pass);
      setUserPosition(user.user_position ? user.user_position.name : "-");
      setUserNameFull(user.name);
      setUserEmail(user.email);
      setUserPhone(user.phone);
    }
  }, [user]);

  const toggleMedia = useCallback(() => {
    if (modalMedia) {
      setModalMedia(false);
    } else {
      setModalMedia(true);
    }
  }, [modalMedia]);

  const toggle = useCallback(() => {
    if (modal) {
      setModal(false);
    } else {
      setModal(true);
    }
  }, [modal]);

  const handleSelectFile = (file) => {
    if (user) {
      const dataEditImage = {
        id: user.id,
        image: file.filename,
        action: "image",
      };
      dispatch(updateUser(dataEditImage));
      toggleMedia();
    }
  };

  useEffect(() => {
    if (!isSearch) {
      dispatch(resetTaskState());
      dispatch(onGetTasks());
      setIsSearch(true);
    }
  }, [dispatch, isSearch, tasks]);

  useEffect(() => {
    if (localStorage.getItem("authUser")) {
      const obj = JSON.parse(localStorage.getItem("authUser"));
      if (obj.data.id) {
        setUserId(obj.data.id);
        dispatch(onGetEmployeeOne(obj.data.id));
      }
    }
  }, [dispatch]);

  function formatBytes(bytes, decimals = 2) {
    if (bytes === 0) return "0 Bytes";
    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];

    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
  }

  document.title = "Profile | Enterprise Resources Planning";

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Row>
            <Col lg={12} className="mt-0">
              <div>
                <Row>
                  <Col xxl={3}>
                    <Card>
                      <CardBody className="p-4">
                        <div className="text-center">
                          <div className="profile-user position-relative d-inline-block mx-auto mb-4 cursor-pointer">
                            <img src={userImage === "" || userImage === null ? logo : `${api.MEDIA_URL}/media/${userImage}`} alt="" className="rounded-circle avatar-xl img-thumbnail user-profile-image" onClick={() => {
                            toggleMedia();
                          }} />
                            <div className="avatar-xs p-0 rounded-circle profile-photo-edit">
                              <div
                                onClick={() => {
                                  if (user) {
                                    const dataEditImage = {
                                      id: user.id,
                                      image: "",
                                      action: "image",
                                    };
                                    dispatch(updateUser(dataEditImage));
                                  }
                                }}
                                className="profile-photo-edit avatar-xs ">
                                {userImage === "" || userImage === null ? (
                                  <span className="avatar-title rounded-circle bg-light text-body">
                                    <i className="ri-camera-fill"></i>
                                  </span>
                                ) : (
                                  <span className="avatar-title rounded-circle bg-light text-body">
                                    <i className="ri-delete-bin-7-fill"></i>
                                  </span>
                                )}
                              </div>
                            </div>
                          </div>
                          <h4 className="mb-1">{userName}</h4>
                          <p className="text-muted mb-3">{userPosition}</p>
                          <button
                            onClick={() => {
                              setIsPass(true);
                              toggle();
                            }}
                            type="button"
                            className="btn btn-soft-danger btn w-75">
                            <i className=" ri-lock-fill fs-12"></i> Ganti Password
                          </button>
                          {/* <button
                              onClick={() => {
                                toggle();
                              }}
                              type="button"
                              className="btn btn-soft-success btn-sm">
                              Edit
                            </button> */}
                        </div>
                      </CardBody>
                    </Card>

                    <Card>
                      <CardHeader className="align-items-center d-flex">
                        <h4 className="card-title mb-0 flex-grow-1">Info</h4>
                      </CardHeader>
                      <CardBody>
                        <div className="table-responsive">
                          <Table className="table-borderless mb-0">
                            <tbody>
                              <tr>
                                <th className="ps-0" scope="row">
                                  Nama Lengkap :
                                </th>
                                <td className="text-muted">{userNameFull}</td>
                              </tr>
                              <tr>
                                <th className="ps-0" scope="row">
                                  Ponsel :
                                </th>
                                <td className="text-muted">{userPhone}</td>
                              </tr>
                              <tr>
                                <th className="ps-0" scope="row">
                                  E-mail :
                                </th>
                                <td className="text-muted">{userEmail}</td>
                              </tr>
                              {/* <tr>
                                <th rowSpan={userLocation ? userLocation.length : 0} className="ps-0" scope="row">
                                  Location :
                                </th>
                                {userLocation && <td className="text-muted">{userLocation[0] === undefined ? "" : userLocation[0].location_branch.branch_name}</td>}
                              </tr>

                              {userLocation &&
                                userLocation.slice(1).map((locationBranch, i) => {
                                  return userLocation.length > 1 ? (
                                    <tr key={i}>
                                      <td className="text-muted">{locationBranch.location_branch.branch_name}</td>
                                    </tr>
                                  ) : null;
                                })} */}
                              {/* 
                              <tr>
                                <th className="ps-0" scope="row">
                                  Joining Date
                                </th>
                                <td className="text-muted">{handleValidDate(userJoinDate)}</td>
                              </tr> */}
                            </tbody>
                          </Table>
                        </div>
                      </CardBody>
                    </Card>
                  </Col>
                  <Col xxl={9}>
                    <Card>
                      <CardBody>
                        <h5 className="card-title mb-3">Tentang</h5>
                        <p>{userDescription}</p>

                        <Row>
                          <div className="card-body">
                            <div className="table-responsive table-card">
                              <Accordion id="default-accordion-example" flush open={open} toggle={toggleAccordion}>
                                <AccordionItem>
                                  <AccordionHeader targetId="1" className="accordion-header" id="headingOne">
                                    INFORMASI PRIBADI
                                  </AccordionHeader>
                                  <AccordionBody accordionId="1">
                                    <div className="row">
                                      <div className="col-lg-7">
                                        <table className="table border table-responsive table-striped fs-13 mb-3">
                                          <tbody>
                                            <tr>
                                              <td>Email</td>
                                              <td>{user && user.user_employee && user.user_employee.email ? user.user_employee.email : "-"}</td>
                                            </tr>
                                            <tr>
                                              <td className="p2">Ponsel</td>
                                              <td className="p2">{user && user.user_employee && user.user_employee.phone ? user.user_employee.phone : "-"}</td>
                                            </tr>
                                            <tr>
                                              <td className="p2">Jenis Kelamin</td>
                                              <td className="p2">{user && user.user_employee && user.user_employee.gender ? user.user_employee.gender : "-"}</td>
                                            </tr>
                                            <tr>
                                              <td className="p2">Tempat Tanggal Lahir</td>
                                              <td className="p2">{user && user.user_employee && user.user_employee.birth_place ? user.user_employee.birth_place + ", " + handleValidDate(user.user_employee.birthat) : "-"}</td>
                                            </tr>
                                            <tr>
                                              <td className="p2">Agama</td>
                                              <td className="p2">{user && user.user_employee && user.user_employee.employee_religion ? user.user_employee.employee_religion.name : "-"}</td>
                                            </tr>
                                            <tr>
                                              <td className="p2">Status Pernikahan </td>
                                              <td className="p2">{user && user.user_employee && user.user_employee.employee_marital_status ? user.user_employee.employee_marital_status.name : "-"}</td>
                                            </tr>
                                            <tr>
                                              <td className="p2">No. Pajak</td>
                                              <td className="p2">{user && user.user_employee && user.user_employee.tax_number ? user.user_employee.tax_number : "-"}</td>
                                            </tr>
                                            <tr>
                                              <td className="p2">No. Asuransi</td>
                                              <td className="p2">{user && user.user_employee && user.user_employee.insurance_number ? user.user_employee.insurance_number : "-"}</td>
                                            </tr>
                                          </tbody>
                                        </table>
                                        <table className="table border table-responsive table-striped fs-13 mb-3">
                                          <tbody>
                                            <tr>
                                              <td className="p2 p2 fw-medium text-primary text-uppercase" colSpan={"2"}>
                                                Identitas
                                              </td>
                                            </tr>
                                            {user && user.user_employee && user.user_employee.employee_identity ? (
                                              user.user_employee.employee_identity.map((row) => {
                                                return (
                                                  <Fragment key={row.id}>
                                                    <tr>
                                                      <td className="p2">Jenis</td>
                                                      <td className="p2">{row.identity_type ? row.identity_type.name : "-"} </td>
                                                    </tr>
                                                    <tr>
                                                      <td className="p2">Utama</td>
                                                      <td className="p2">{row.isPrimary ? "Iya" : "Tidak"} </td>
                                                    </tr>
                                                    <tr>
                                                      <td className="p2">Nomor</td>
                                                      <td className="p2">{row.identity_number ? row.identity_number : "-"} </td>
                                                    </tr>
                                                  </Fragment>
                                                );
                                              })
                                            ) : (
                                              <tr></tr>
                                            )}
                                          </tbody>
                                        </table>
                                        <table className="table border table-responsive table-striped fs-13 mb-3">
                                          <tbody>
                                            <tr>
                                              <td className="p2 fw-medium text-primary text-uppercase" colSpan={"2"}>
                                                Alamat
                                              </td>
                                            </tr>
                                            {user && user.user_employee && user.user_employee.employee_address ? (
                                              user.user_employee.employee_address.length > 0 ? (
                                                user.user_employee.employee_address.map((row) => {
                                                  return (
                                                    <Fragment key={row.id}>
                                                      <tr>
                                                        <td className="p2">Judul</td>
                                                        <td className="p2">{row.address_name ? row.address_name : "-"} </td>
                                                      </tr>
                                                      <tr>
                                                        <td className="p2">Utama</td>
                                                        <td className="p2">{row.isPrimary ? "Iya" : "Tidak"} </td>
                                                      </tr>
                                                      <tr>
                                                        <td className="p2">Tipe</td>
                                                        <td className="p2">{row.address_type ? row.address_type.address_type_name : "-"} </td>
                                                      </tr>
                                                      <tr>
                                                        <td className="p2">Provinsi</td>
                                                        <td className="p2">{row.av ? row.av.vp.province_name : "-"} </td>
                                                      </tr>
                                                      <tr>
                                                        <td className="p2">Kota</td>
                                                        <td className="p2">{row.av ? row.av.vc.city_name : "-"} </td>
                                                      </tr>
                                                      <tr>
                                                        <td className="p2">Kecamatan</td>
                                                        <td className="p2">{row.av ? row.av.vd.district_name : "-"} </td>
                                                      </tr>
                                                      <tr>
                                                        <td className="p2">Keluruhan</td>
                                                        <td className="p2">{row.av ? row.av.village_name : "-"} </td>
                                                      </tr>
                                                      <tr>
                                                        <td className="p2">Kode Pos</td>
                                                        <td className="p2">{row.av ? row.av.zip : "-"} </td>
                                                      </tr>
                                                      <tr>
                                                        <td className="p2">Jalan</td>
                                                        <td className="p2">{row.av ? row.description : "-"} </td>
                                                      </tr>
                                                    </Fragment>
                                                  );
                                                })
                                              ) : (
                                                <div className="d-flex justify-content-center">
                                                  <span>-</span>
                                                </div>
                                              )
                                            ) : (
                                              <div className="d-flex justify-content-center">
                                                <span>-</span>
                                              </div>
                                            )}
                                          </tbody>
                                        </table>
                                      </div>
                                      <div className="col-lg-5">
                                        <table className="table border table-responsive table-striped fs-13 mb-3">
                                          <tbody>
                                            <tr>
                                              <td className="p2 p2 fw-medium text-primary text-uppercase" colSpan={"2"}>
                                                INFORMASI BANK
                                              </td>
                                            </tr>
                                            {user && user.user_employee && user.user_employee.employee_bank ? (
                                              user.user_employee.employee_bank.length > 0 ? (
                                                user.user_employee.employee_bank.map((row) => {
                                                  return (
                                                    <Fragment key={row.id}>
                                                      <tr>
                                                        <td className="p2" colSpan="2">
                                                          {row.bank_data_bank ? row.bank_data_bank.name : "-"}                                </td>
                                                      </tr>
                                                      <tr>
                                                        <td className="p2">Utama</td>
                                                        <td className="p2">{row.isPrimary ? "Iya" : "Tidak"} </td>
                                                      </tr>
                                                      <tr>
                                                        <td className="p2">No. Rekening Bank</td>
                                                        <td className="p2">{row.number ? row.number : "-"} </td>
                                                      </tr>
                                                    </Fragment>
                                                  );
                                                })
                                              ) : (
                                                <div className="d-flex justify-content-center">
                                                  <span>-</span>
                                                </div>
                                              )
                                            ) : (
                                              <div className="d-flex justify-content-center">
                                                <span>-</span>
                                              </div>
                                            )}
                                          </tbody>
                                        </table>
                                        <table className="table border table-responsive table-striped fs-13 mb-3">
                                          <tbody>
                                            <tr>
                                              <td className="p2 p2 fw-medium text-primary text-uppercase" colSpan={"2"}>
                                                Pendidikan
                                              </td>
                                            </tr>
                                            {user && user.user_employee && user.user_employee.employee_education ? (
                                              user.user_employee.employee_education.length > 0 ? (
                                                user.user_employee.employee_education.map((row) => {
                                                  return (
                                                    <Fragment key={row.id}>
                                                      <tr>
                                                        <td className="p2">
                                                          {row.name ? row.name : "-"} ({row.education_level ? row.education_level.name : "-"}
                                                          ) <br />                                  <small>
                                                            {row.startat && handleValidDate(row.startat)} - {row.endat && handleValidDate(row.endat)}                                  </small>
                                                        </td>
                                                      </tr>
                                                    </Fragment>
                                                  );
                                                })
                                              ) : (
                                                <div className="d-flex justify-content-center">
                                                  <span>-</span>
                                                </div>
                                              )
                                            ) : (
                                              <div className="d-flex justify-content-center">
                                                <span>-</span>
                                              </div>
                                            )}
                                          </tbody>
                                        </table>
                                        <table className="table border table-responsive table-striped fs-13 mb-3">
                                          <tbody>
                                            <tr>
                                              <td className="p2 p2 fw-medium text-primary text-uppercase" colSpan={"2"}>
                                                Kontak Keluarga
                                              </td>
                                            </tr>
                                            {user && user.user_employee && user.user_employee.employee_family_contact ? (
                                              user.user_employee.employee_family_contact.length > 0 ? (
                                                user.user_employee.employee_family_contact.map((row) => {
                                                  return (
                                                    <Fragment key={row.id}>
                                                      <tr>
                                                        <td className="p2" colSpan="2">
                                                          {row.family_contact_type ? row.family_contact_type.type_name : "-"}                                </td>
                                                      </tr>
                                                      <tr>
                                                        <td className="p2">Nama</td>
                                                        <td className="p2">{row.name ? row.name : "-"} </td>
                                                      </tr>
                                                      <tr>
                                                        <td className="p2">Nomor</td>
                                                        <td className="p2">{row.phone ? row.phone : "-"} </td>
                                                      </tr>
                                                    </Fragment>
                                                  );
                                                })
                                              ) : (
                                                <div className="d-flex justify-content-center">
                                                  <span>-</span>
                                                </div>
                                              )
                                            ) : (
                                              <div className="d-flex justify-content-center">
                                                <span>-</span>
                                              </div>
                                            )}
                                          </tbody>
                                        </table>
                                      </div>
                                    </div>
                                  </AccordionBody>
                                </AccordionItem>
                                <AccordionItem>
                                  <AccordionHeader targetId="2" className="accordion-header" id="headingTwo">
                                    INFORMASI PEKERJAAN
                                  </AccordionHeader>
                                  <AccordionBody accordionId="2">
                                    <table className="table table-responsive table-striped fs-12">
                                      <tbody>
                                        <tr>
                                          <td className="p2"> Perusahaan</td>
                                          <td className="p2">{user && user.user_company && user.user_company.name ? user.user_company.name : "-"}</td>
                                        </tr>
                                        {/* <tr>
                                          <td className="p2">Join Date</td>
                                          <td className="p2">{employee.joinat ? handleValidDate(employee.joinat) : "-"}</td>
                                        </tr> */}
                                        <tr>
                                          <td className="p2">Departemen </td>
                                          <td className="p2">{user && user?.user_department && user?.user_department?.name ? user?.user_department?.name : "-"}</td>
                                        </tr>
                                        <tr>
                                          <td className="p2"> Posisi Kerja</td>
                                          <td className="p2">{user && user.user_position && user.user_position.name ? user.user_position.name : "-"}</td>
                                        </tr>
                                      </tbody>
                                    </table>
                                    <div>
                                      <table className="table table-responsive table-striped fs-12">
                                        <tbody>
                                          <tr>
                                            <td className="p2 p2 fw-medium text-primary text-uppercase" colSpan={"2"}>
                                              Lokasi Kerja
                                            </td>
                                          </tr>
                                          {user && user.user_location ? (
                                            user.user_location.length > 0 ? (
                                              user.user_location
                                                .filter((data) => data.isPrimary === true)
                                                .map((row) => {
                                                  return (
                                                    <Fragment key={row.id}>
                                                      <tr>
                                                        <td className="p2" colSpan="2">
                                                          {row.location_branch ? row.location_branch.name : "-"}                                </td>
                                                      </tr>
                                                    </Fragment>
                                                  );
                                                })
                                            ) : (
                                              <div className="d-flex justify-content-center">
                                                <span>-</span>
                                              </div>
                                            )
                                          ) : (
                                            <div className="d-flex justify-content-center">
                                              <span>-</span>
                                            </div>
                                          )}
                                        </tbody>
                                      </table>
                                    </div>
                                  </AccordionBody>
                                </AccordionItem>
                                {/* <AccordionItem>
                                  <AccordionHeader targetId="3" className="accordion-header" id="headingThree">
                                    OTHER INFORMATION
                                  </AccordionHeader>
                                  <AccordionBody accordionId="3">
                                    <table className="table table-responsive table-striped fs-12">
                                      <tbody>
                                        <tr>
                                          <td className="p2">Dibuat Oleh</td>
                                          <td className="p2">{employee.employee_createdby && employee.employee_createdby.name ? employee.employee_createdby.name + " - " + handleValidDate(employee.createdat) : "-"}</td>
                                        </tr>
                                        <tr>
                                          <td className="p2">Diedit Oleh</td>
                                          <td className="p2">{employee.employee_updatedby && employee.employee_updatedby.name ? employee.employee_updatedby.name + " - " + handleValidDate(employee.updatedat) : "-"}</td>
                                        </tr>
                                        <tr>
                                          <td className="p2">Approved By</td>
                                          <td className="p2">{employee.employee_approvedby && employee.employee_approvedby.name ? employee.employee_approvedby.name + " - " + handleValidDate(employee.approvedat) : "-"}</td>
                                        </tr>
                                      </tbody>
                                    </table>
                                  </AccordionBody>
                                </AccordionItem> */}
                              </Accordion>
                            </div>
                          </div>
                        </Row>
                      </CardBody>
                    </Card>
                  </Col>
                </Row>
              </div>
            </Col>
          </Row>
          <Modal id="showModal" isOpen={modal} centered size="md">
            <ModalHeader
              className="bg-light p-3"
              toggle={() => {
                toggle();
                setTimeout(() => {
                  setIsPass(false);
                }, 200);
              }}>
              {isPass ? "Change Password" : "Edit Profile"}
            </ModalHeader>
            <Form
              onSubmit={(e) => {
                e.preventDefault();
                validation.handleSubmit();
                return false;
              }}>
              <ModalBody>
                <div className="row">
                  <div className="col-lg-12">
                    {isPass ? (
                      <>
                        <div className="mb-3">
                          <Label htmlFor="password-field" className="form-label">
                            Password <span className="text-danger">*</span>
                          </Label>
                          <Input name="password" id="password-field" className="form-control" placeholder="Enter Password" type="password" validate={{ required: { value: true } }} onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.password ?? ""} invalid={validation.touched.password && validation.errors.password ? true : false} />
                          {validation.touched.password && validation.errors.password ? (
                            <small className="text-danger" type="invalid">
                              {validation.errors.password}
                            </small>
                          ) : null}
                        </div>
                      </>
                    ) : (
                      <>
                        <div className="mb-3">
                          <Label htmlFor="name-field" className="form-label">
                            Name
                          </Label>
                          <Input name="name" id="name-field" className="form-control" placeholder="Isi Nama" type="text" validate={{ required: { value: true } }} onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.name ?? ""} invalid={validation.touched.name && validation.errors.name ? true : false} />
                          {validation.touched.name && validation.errors.name ? <FormFeedback type="invalid">{validation.errors.name}</FormFeedback> : null}
                        </div>
                        <div className="mb-3">
                          <Label htmlFor="name-field" className="form-label">
                            Email
                          </Label>
                          <Input name="name" id="name-field" className="form-control" placeholder="Isi Nama" type="text" validate={{ required: { value: true } }} onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.email ?? ""} invalid={validation.touched.email && validation.errors.email ? true : false} />
                          {validation.touched.email && validation.errors.email ? <FormFeedback type="invalid">{validation.errors.email}</FormFeedback> : null}
                        </div>
                        <div className="mb-3">
                          <Label htmlFor="name-field" className="form-label">
                            Phone
                          </Label>
                          <Input name="name" id="name-field" className="form-control" placeholder="Isi Nama" type="text" validate={{ required: { value: true } }} onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.phone ?? ""} invalid={validation.touched.phone && validation.errors.phone ? true : false} />
                          {validation.touched.phone && validation.errors.phone ? <FormFeedback type="invalid">{validation.errors.phone}</FormFeedback> : null}
                        </div>
                      </>
                    )}
                  </div>
                </div>
              </ModalBody>
              <div className="modal-footer">
                <div className="hstack gap-2 justify-content-end">
                  <button
                    type="button"
                    className="btn btn-light"
                    onClick={() => {
                      toggle();
                    }}>Close
                  </button>
                  <button type="submit" className="btn btn-success">
                    <span className="d-flex align-items-center">
                      <span className="flex-grow-1 me-2">{"Update"}</span>
                      {loading ? (
                        <Spinner size="sm" className="flex-shrink-0" role="status">
                          Loading...
                        </Spinner>
                      ) : (
                        ""
                      )}
                    </span>
                  </button>
                </div>
              </div>
            </Form>
          </Modal>

          <ModalInputFile onSelect={handleSelectFile} loading={loading} modal={modalMedia} toggle={toggleMedia} />

        </Container>
      </div>
    </React.Fragment>
  );
};

export default SimplePage;
